type ScaleDeboundOptions = { multiplier?: number; max?: number };

export const scaledDebounce = (func: any, baseTimeout: number, options?: ScaleDeboundOptions): any => {
  options = options || {};
  const multiplier = options.multiplier || 0;
  const max = options.max || 0;

  const getTimeout = (stack) => {
    const timeout = baseTimeout + stack * multiplier;
    return max ? Math.min(timeout, max) : timeout;
  };

  let counter = 0;
  let timer;
  return (...args) => {
    clearTimeout(timer);
    const timeout = getTimeout(counter);
    counter++;
    timer = setTimeout(() => {
      counter = 0;
      func.apply(this, args);
    }, timeout);
  };
};
